"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicErrorPage = PublicErrorPage;
const react_1 = __importDefault(require("react"));
const error_1 = __importDefault(require("next/error"));
/**
 * Default public error component
 * @param { number } statusCode error status code
 * @returns A react Error component
 */
function PublicErrorPage({ statusCode }) {
    return react_1.default.createElement(error_1.default, { statusCode: statusCode });
}
PublicErrorPage.getInitialProps = ({ res, err }) => {
    const statusCode = res?.statusCode || err?.statusCode || 404;
    return { statusCode };
};
PublicErrorPage.auth = {
    isPublic: true,
};
